module.exports = __webpack_public_path__ + "media/images/help/alt-3888caa58c1ed016f28077fc286f590d.png";